import React, { Suspense, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "./common/PrivateRoute";
import LoginNew from "./qureal_auth/LoginNew";
import VerifyAuth from "./auth/VerifyAuth";
import { REGISTER_COMP } from "./constants";
import { Layout } from "antd";
import ReactGA from "react-ga4";
import LoadingFull from "./common/LoadingFull";
import NewHome from "./home/NewHome";

import { safeLazy } from "./_helpers/lazy";

// Route-level lazy loading — webpack splits each into a separate chunk
const ForgotPassword = safeLazy(() => import("./auth/ForgotPassword"));
const ResetPassword = safeLazy(() => import("./auth/ResetPassword"));
const OrgSetup = safeLazy(() => import("./auth/OrgSetup"));
const OTPScreen = safeLazy(() => import("./auth/OTPScreen"));
const PrivacyPolicy = safeLazy(() =>
    import("./payments/extras/PrivacyPolicy")
);
const TermsAndConditions = safeLazy(() =>
    import("./payments/extras/TermsAndConditions")
);
const OneTemplate = safeLazy(() => import("./public_views/OneTemplate"));
const OnboardingScreen = safeLazy(() =>
    import("./onboarding/OnboardingScreen")
);
const Junction = safeLazy(() => import("./blog/Junction"));
// const NewHome = React.lazy(() => import("./home/NewHome"));
// import BillingPage from "./billing/BillingPage";
const { Content } = Layout;

const App = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: window.location.pathname,
            //  title: "Custom Title"
        });
    }, []);

    return (
        <Content>
            <Suspense fallback={<LoadingFull text="Loading in App" />}>
                <Switch>
                    {/* <Route exact path="/login" component={Login} /> */}
                    <Route exact path="/login" component={LoginNew} />
                    <Route
                        exact
                        path="/privacy_policy"
                        component={PrivacyPolicy}
                    />
                    <Route exact path="/templates" component={OneTemplate} />
                    <Route
                        exact
                        path="/terms_and_conditions"
                        component={TermsAndConditions}
                    />
                    <Route exact path="/verify_auth" component={VerifyAuth} />
                    <Route
                        exact
                        path="/register"
                        component={() => {
                            return (
                                <Suspense fallback={() => <h3>Loading...</h3>}>
                                    <REGISTER_COMP />
                                </Suspense>
                            );
                        }}
                    />
                    <Route
                        exact
                        path="/forgot_password"
                        component={ForgotPassword}
                    />
                    <Route
                        exact
                        path="/verify_password"
                        component={ResetPassword}
                    />
                    <Route
                        exact
                        path="/verify_otp"
                        // component={VerifyOTP}
                        component={OTPScreen}
                    />
                    <Route
                        path={`/blog/:blogId`}
                        component={(routeProps) => <Junction {...routeProps} />}
                    />
                    <PrivateRoute
                        exact
                        path="/setup_org"
                        component={OrgSetup}
                    />

                    <PrivateRoute
                        path="/new_setup"
                        component={OnboardingScreen}
                    />
                    {/* <PrivateRoute path="/billing" component={BillingPage} /> */}

                    {/* <PrivateRoute path="/" component={Home} /> */}
                    <PrivateRoute path="/" component={NewHome} />
                </Switch>
            </Suspense>
        </Content>
        // </div>
    );
};

export default App;
